import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import NextImage from 'next/legacy/image';
import { Box, Desktop, Mobile, useWindowSize, prefixUrl } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ImageWrapper = styled(Box).withConfig({
  displayName: "CardImage__ImageWrapper",
  componentId: "sc-15bnkht-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["border:1px solid var(--wcds-templates-card-border-color);overflow:hidden;img{object-fit:cover;}"]);
});

var CardImage = function CardImage(_ref2) {
  var onShowCardDescription = _ref2.onShowCardDescription,
      mobileImage = _ref2.mobileImage,
      image = _ref2.image,
      wrapperStyles = _ref2.wrapperStyles,
      className = _ref2.className,
      _ref2$priority = _ref2.priority,
      priority = _ref2$priority === void 0 ? false : _ref2$priority;
  var theme = useTheme();
  var windowSize = useWindowSize();
  var isMobileViewPort = windowSize.width && windowSize.width < theme.breakpoints.small;

  if (!image.original.webp) {
    return null;
  }

  var getImages = function getImages() {
    var placeholder = {
      placeholder: undefined,
      blurDataURL: undefined
    };

    if (!priority) {
      placeholder.placeholder = 'blur';
      placeholder.blurDataURL = prefixUrl(image.placeholder.webp);
    }

    var desktopImageElement = /*#__PURE__*/_jsx(NextImage, _objectSpread({
      layout: "fill",
      src: prefixUrl(image.original.webp),
      unoptimized: true,
      alt: image.name,
      priority: priority
    }, placeholder));

    if (mobileImage) {
      desktopImageElement = /*#__PURE__*/_jsx(Desktop, {
        children: desktopImageElement
      });

      if (!priority) {
        placeholder.blurDataURL = prefixUrl(mobileImage.placeholder.webp);
      }

      var mobileImageElement = /*#__PURE__*/_jsx(Mobile, {
        children: /*#__PURE__*/_jsx(NextImage, _objectSpread({
          layout: "fill",
          src: prefixUrl(mobileImage.original.webp),
          unoptimized: true,
          alt: mobileImage.name,
          priority: priority
        }, placeholder))
      });

      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [desktopImageElement, mobileImageElement]
      });
    }

    return desktopImageElement;
  };

  return /*#__PURE__*/_jsx(ImageWrapper, {
    className: className,
    $styles: wrapperStyles,
    onClick: function onClick(e) {
      if (!isMobileViewPort) {
        return;
      }

      onShowCardDescription(e);
    },
    children: getImages()
  });
};

export default CardImage;